import { render, staticRenderFns } from "./PleaseWait.vue?vue&type=template&id=483b90e8&scoped=true&"
import script from "./PleaseWait.vue?vue&type=script&lang=ts&"
export * from "./PleaseWait.vue?vue&type=script&lang=ts&"
import style0 from "./PleaseWait.vue?vue&type=style&index=0&id=483b90e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "483b90e8",
  null
  
)

export default component.exports